import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const LaunchSequenceModal = ({ onClose }) => {
  const [inputValue, setInputValue] = useState('');
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleAuthorize = (e) => {
    e.preventDefault();
    if (inputValue === 'CONFIRM') {
      setIsAuthorizing(true);
      setTimeout(() => {
        setIsAuthorizing(false);
        setSuccess(true);
        setTimeout(onClose, 2000);
      }, 2000);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="absolute inset-0 bg-slate-950/90 backdrop-blur-md"
        onClick={onClose}
      />
      
      <motion.div 
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="bg-slate-900 border border-rocket-500/50 p-8 rounded-xl shadow-[0_0_50px_rgba(249,115,22,0.15)] relative z-10 w-full max-w-md tech-border"
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-500 hover:text-ice">
          <SafeIcon name="X" />
        </button>

        <AnimatePresence mode="wait">
          {!success ? (
            <motion.div key="form" exit={{ opacity: 0 }} className="text-center">
              <div className="w-16 h-16 bg-rocket-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-rocket-500/30">
                <SafeIcon name="Shield" className="text-3xl text-rocket-500" />
              </div>
              <h2 className="text-xl font-bold text-ice mb-2">Authorize Stage Gate</h2>
              <p className="text-sm text-slate-400 mb-6 font-mono">
                WARNING: Advancing to <span className="text-rocket-400">STAGE 4: PRESS BRIEFINGS</span> will trigger automated comms relays.
              </p>

              <form onSubmit={handleAuthorize}>
                <div className="mb-6 text-left">
                  <label className="block text-xs font-mono text-slate-500 mb-2">TYPE "CONFIRM" TO PROCEED</label>
                  <input 
                    type="text" 
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-700 rounded px-4 py-3 text-ice font-mono focus:border-rocket-500 focus:outline-none focus:ring-1 focus:ring-rocket-500 transition-all uppercase"
                    placeholder="ENTER OVERRIDE CODE"
                  />
                </div>
                
                <button 
                  disabled={inputValue !== 'CONFIRM' || isAuthorizing}
                  className={`w-full py-3 rounded font-bold tracking-wider transition-all flex justify-center items-center ${
                    inputValue === 'CONFIRM' && !isAuthorizing
                      ? 'bg-rocket-600 hover:bg-rocket-500 text-white shadow-[0_0_15px_rgba(249,115,22,0.4)]' 
                      : 'bg-slate-800 text-slate-500 cursor-not-allowed'
                  }`}
                >
                  {isAuthorizing ? (
                    <SafeIcon name="Loader" className="animate-spin text-xl" />
                  ) : (
                    'INITIATE SEQUENCE'
                  )}
                </button>
              </form>
            </motion.div>
          ) : (
            <motion.div key="success" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} className="text-center py-8">
              <div className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-4 border border-green-500/30">
                <SafeIcon name="Check" className="text-4xl text-green-500" />
              </div>
              <h2 className="text-xl font-bold text-ice mb-2">Sequence Authorized</h2>
              <p className="text-sm text-slate-400 font-mono">Stage 4 protocols engaged.</p>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default LaunchSequenceModal;